<span class="cont-icon" [ngClass]="form">
    <span class="fa-stack phone">
        <i class="fa famc famc-device-phone-b fa-fw fa-2x fa-stack-1x bg-color"></i>
        <i class="fa famc famc-device-phone fa-fw fa-2x fa-stack-1x"></i>
    </span>
    <span class="fa-stack tablet">
        <i class="fa famc famc-device-tablet-b fa-fw fa-2x fa-stack-1x bg-color"></i>
        <i class="fa famc famc-device-tablet fa-fw fa-2x fa-stack-1x"></i>
    </span>
    <span class="fa-stack desktop">
        <i class="fa famc famc-device-desktop-b fa-fw fa-2x fa-stack-1x bg-color"></i>
        <i class="fa famc famc-device-desktop fa-fw fa-2x fa-stack-1x"></i>
    </span>
    <span class="compliance" [ngClass]="complianceStatus">
        <i class="fa famc hd-icon-pending pending"></i>
        <i class="fa famc famc-compliant compliant"></i>
        <i class="fa famc famc-not-compliant non-compliant"></i>
    </span>
</span>
